import {appendElement, createElement, mergeObjects} from '../helpers';
import {Api} from '../api/api';
import {FinOfferClickManager} from '../../front/domains/financialOffer/finOfferClickManager';
import {OfferClickManager} from '../../front/domains/offer/offerClickManager';
import {LazyImages} from '../lazyLoad/lazyImages';
import {Popup} from '../popup';
import OfferViewFacade from '../../front/domains/offer/offerViewFacade';

class PaginatedContent {
    /**
     * @param {Element} content
     * @param {Object} defaultFilters
     * @param {Object} defaultOrder
     */
    constructor(content, defaultFilters = {}, defaultOrder = {}) {
        if (!content) {
            return;
        }

        this.container = content;
        this.list = this.container.querySelector('[data-content="list"]');
        this.buttonMore = this.container.querySelector('[data-content="button-more"]');

        this.page = 1;
        this.order = defaultOrder;
        this.filters = defaultFilters;

        let leftCount = this.buttonMore ? this.buttonMore.querySelector('[data-content="count-left"]') : 0;
        this.hasMoreContent = Boolean(leftCount);

        this.endpoint = this.container.getAttribute('data-endpoint') !== null
            ? this.container.getAttribute('data-endpoint')
            : location.href;

        this.initListeners();
        this.initContentListeners();
    }

    initListeners() {
        if (this.buttonMore) {
            this.buttonMore.addEventListener('click', (event) => {
                event.preventDefault();
                this.paginate();
            });
        }

        OfferClickManager.init(this.container);
        FinOfferClickManager.init(this.container);
        OfferViewFacade.notifyAboutAllAvailable(this.container);
    }

    initContentListeners() {}

    /**
     * @param {String} name
     * @param {String} value
     */
    setFilter(name, value) {
        this.filters[name] = value;
    }

    clearFilters() {
        this.filters = {};
    }

    /**
     * @param {String} column
     * @param {String} direction
     */
    setOrder(column, direction) {
        this.order['order_by'] = column;
        this.order['order_dir'] = direction;
    }

    setLoadElementCallback(callback) {
        this.loadElementCallback = callback;
    }

    get requestParams() {
        return mergeObjects({page: this.page}, this.filters, this.order)
    }

    clearContent() {
        this.list.querySelectorAll('[data-list]').forEach((element) => element.remove());
    }

    /** @param {Element} content */
    replaceContent(content) {
        this.clearContent();
        this.appendContent(content);
    }

    /** @param {Element} content */
    appendContent(content) {
        Array.from(content.children).forEach((element) => {
            appendElement(element, this.list);

            if (this.loadElementCallback) {
                this.loadElementCallback(element)
            }
        });
    }

    reload() {
        this.page = 1;
        this.load();
    }

    paginate() {
        this.page++;
        this.load();
    }

    showButtonMore() {
        return (this.buttonMore && this.hasMoreContent) ? this.buttonMore.style.display = '' : false;
    }

    hideButtonMore() {
        return this.buttonMore ? this.buttonMore.style.display = 'none' : false;
    }

    /**
     * @param {Number} leftCount
     * @return {boolean}
     */
    setLeftCount(leftCount) {
        let element = this.buttonMore ? this.buttonMore.querySelector('[data-content="count-left"]') : null;

        if (!element) {
            return false;
        }

        element.textContent = String(leftCount);
        return true;
    }

    load() {
        Api.post(this.endpoint, this.requestParams, (response) => {
            if (response.isFailure()) {
                return this.hideButtonMore();
            }

            let contentObject = createElement(response.get('content', ''), this.list.tagName),
                leftCount = response.get('leftCount', 0);

            if (this.page === 1) {
                this.replaceContent(contentObject);
                this.initContentListeners();
            } else {
                this.appendContent(contentObject);
            }

            LazyImages.load();
            Popup.initToggle();

            this.hasMoreContent = Boolean(leftCount);

            if (leftCount <= 0) {
                return this.hideButtonMore();
            }

            if (leftCount !== undefined) {
                this.setLeftCount(leftCount);
            }

            return this.showButtonMore();
        });
    }
}

export {PaginatedContent};
